/* nm-pg-testimonials : flèches précédent / suivant du carrousel mobile */
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('.ntst__track');
    root.querySelectorAll('.ntst__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.ntst__card'); if (!card) return;
        var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        var dir = btn.dataset.dir === 'prev' ? -1 : 1;
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + dir * step;
        if (next > max + 2) next = 0; else if (next < -2) next = max;
        track.scrollTo({ left: next, behavior: 'smooth' });
      });
    });
  }
  function all() { document.querySelectorAll('.nm-pg-tst').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
